<template>
  <div class="register">
    <img class="logo" src="@/assets/images/logo.png" alt="" />
    <div class="c-container">
      <van-radio-group class="login-type" v-model="loginType" direction="horizontal">
        <van-radio name="1" icon-size="15" checked-color="#00C896">我是家长</van-radio>
        <van-radio name="2" icon-size="15" checked-color="#00C896">我是老师</van-radio>
      </van-radio-group>
      <div class="input_row">
        <!-- <span class="tip">+86&nbsp;&nbsp;|</span> -->
        <input v-model="form.phone" maxlength="11" placeholder="输入手机号" type="text" />
      </div>
      <div class="input_row">
        <input v-model="form.phonecode" maxlength="6" placeholder="输入验证码" type="text" />
        <button
          :disabled="disabled"
          @click="getCode"
          :style="{ color: codeBtnColor }"
          class="input_code"
        >
          {{ btnTitle }}
        </button>
      </div>
      <van-checkbox class="topLg" v-model="checked"  icon-size="15" checked-color="#00C896"
        >我已阅读并同意<span class="secondary">《巨浪校园用户须知》</span></van-checkbox
      >
      <div class="topLg">
        <van-button class="commonBtn" type="primary" block @click="submitRegister">确认绑定</van-button>
      </div>
      <!-- <button :disabled="isClick" class="btn" @click="submitRegister">
        确定
      </button> -->
    </div>

    <!-- <div class="des">
      巨浪物联网信息技术（湖州）有限公司
    </div> -->
  </div>
</template>

<script>
import { Toast } from 'vant'
import { publicFn } from '@/utils'

export default {
  name: 'register',
  data() {
    return {
      checked: true,
      loginType: '1',
      form: {
        phone: '',
        phonecode: ''
      },
      codeBtnColor: '#07c160',
      btnTitle: '获取验证码',
      disabled: false,
      time: 60,
      timer: null
    }
  },
  computed: {
    isClick() {
      if (!this.form.phone || !this.form.phonecode) return true
      else return false
    }
  },
  created() {
    var ua = window.navigator.userAgent.toLowerCase()
    // ua.indexOf('micromessenger')为真-微信端，如果为假，就是其他浏览器
    if (ua.indexOf('micromessenger') > -1) {
      // 是微信端
      localStorage.removeItem('code')
      localStorage.removeItem('studentId')
      localStorage.removeItem('state')
      // 成功
      if (publicFn.getUrlParam('code') && publicFn.getUrlParam('code') !== '') {
        localStorage.setItem('code', publicFn.getUrlParam('code'))
        this.getStudentData()
      } else {
        window.location.href =
          'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx89ad6ca738b0049b&redirect_uri=http://weixin.julangwulian.com/login&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect'
      }
    } else {
      localStorage.setItem('code', 2222)
      localStorage.setItem('state', 2222)
      this.$http
        .json_post(this.$api.user.openId, {
          code: '123123'
        })
        .then(data => {
          if (data.code == 200) {
            // this.$router.push({ name: 'home' })
          } else {
            // this.$router.push({ name: 'login' })
          }
        })
    }

    // localStorage.removeItem('code')
    // localStorage.removeItem('studentId')
    // localStorage.removeItem('state')
    // // 成功
    // if (publicFn.getUrlParam('code') && publicFn.getUrlParam('code') !== '') {
    //   localStorage.setItem('code', publicFn.getUrlParam('code'))
    //   this.getStudentData()
    // } else {
    //   window.location.href =
    //     'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx89ad6ca738b0049b&redirect_uri=http://weixin.julangwulian.com/login&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect'
    // }

    // 测试
    // alert(111)
    // localStorage.setItem('code', 2222)
    // localStorage.setItem('state', 2222)

    // this.$http
    //   .json_post(this.$api.user.openId, {
    //     code: '123123'
    //   })
    //   .then(data => {
    //     if (data.code == 200) {
    //       // this.$router.push({ name: 'home' })
    //     } else {
    //       // this.$router.push({ name: 'login' })
    //     }
    //   })

    // if (publicFn.getUrlParam('code') && publicFn.getUrlParam('code') !== '') {
    //   this.$http
    //     .json_post(this.$api.user.openId, {
    //       code: publicFn.getUrlParam('code')
    //     })
    //     .then(data => {
    //       alert(data)
    //       if (data.code == 200) {
    //         this.$router.push({ name: 'home' })
    //       } else {
    //         this.$router.push({ name: 'login' })
    //       }
    //     })
    // } else {
    //   window.location.href =
    //     'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx89ad6ca738b0049b&redirect_uri=http://card.liyuyanxue.com/login&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect'
    // }
    // 正式备份
    // alert(publicFn.getUrlParam('code'))
    // if (publicFn.getUrlParam('code') && publicFn.getUrlParam('code') !== '') {
    //   this.$http.json_post(this.$api.user.openId, { code: code }).then(data => {
    //     alert(data)
    //     if (data.code == 200) {
    //       alert(data)
    //     } else {
    //       this.loading = false
    //     }
    //   })
    // } else {
    //   window.location.href =
    //     'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx89ad6ca738b0049b&redirect_uri=http://card.liyuyanxue.com/login&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect'
    // }
  },
  methods: {
    // 获取学生信息
    getStudentData() {
      const code = publicFn.getUrlParam('code')
      if (code && code != '') {
        this.$http
          .json_post(this.$api.user.openId, {
            code: code
          })
          .then(data => {
            if (data.code == 200) {
              if (localStorage.getItem('studentId')) {
                this.$router.push({ name: 'home' })
              } else {
                this.$router.push({ name: 'student' })
              }
            } else {
              localStorage.setItem('state', '可以登录')
            }
          })
      }
    },

    // 获取验证码
    getCode() {
      if (this.validatePhone()) {
        this.valildateBtn()
        this.$http.json_post(this.$api.user.code, { phone: this.form.phone }).then(data => {
          if (data.code == 201) {
            clearInterval(this.timer)
            this.time = 60
            this.btnTitle = '获取验证码'
            this.disabled = false
            this.codeBtnColor = '#07c160'
          }
        })
      }
    },

    // 倒计时
    valildateBtn() {
      if (this.time === 0) {
        clearInterval(this.timer)
        this.time = 60
        this.btnTitle = '获取验证码'
        this.disabled = false
        this.codeBtnColor = '#07c160'
      } else {
        // 倒计时
        this.time--
        this.btnTitle = this.time + 's'
        this.disabled = true
        this.codeBtnColor = '#ccc'
      }
      this.timer = setInterval(() => {
        if (this.time === 0) {
          clearInterval(this.timer)
          this.time = 60
          this.btnTitle = '获取验证码'
          this.disabled = false
          this.codeBtnColor = '#07c160'
        } else {
          // 倒计时
          this.time--
          this.btnTitle = this.time + 's'
          this.disabled = true
          this.codeBtnColor = '#ccc'
        }
      }, 1000)
    },

    // 验证手机号
    validatePhone() {
      if (!this.form.phone) {
        Toast('手机号不能为空')
        return false
      }  else {
        return true
      }
      // else if (!/^1[345678]\d{9}$/.test(this.form.phone)) {
      //   Toast('请填写正确的手机号码')
      //   return false
      // }
    },

    // 提交注册信息
    submitRegister() {
      this.$http.json_post(this.$api.user.login, this.form).then(data => {
        if (data.code == 200) {
          this.$http.json_post(this.$api.user.userPhone).then(data => {
            if ((data.code == 200, '12')) {
              localStorage.removeItem('state')
              this.$router.push({ name: 'student' })
            }
          })
          // this.$router.push({ name: 'student' })
        }
      })
    }
  },
  beforeDestroy() {
    window.clearInterval(this.timer)
  },
  components: {
    Toast
  }
}
</script>

<style lang="scss" scoped>
.register {
  width: 100%;
  height: 100vh;
  background: #fff url('../../assets/images/bg.png') no-repeat bottom left;
  background-size: 75.7%;

  .logo {
    display: block;
    width: 112px;
    margin: 0 auto 45px;
    padding-top: 40px;
  }
}

.user_info {
  padding: 33px 18px 0;
  margin-bottom: 75px;
  img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
  }
  .user_item {
    margin-left: 0px;
    .user_name {
      margin-top: 5px;
      font-size: 24px;
      font-weight: bold;
      color: $primary-color;
    }
    .user_code {
      margin-top: 10px;
      font-size: 13px;
      font-weight: 500;
      color: #999;
    }
  }
}

.login-type {
  margin-bottom: 10px;
}

.input_row {
  display: flex;
  align-items: center;
  position: relative;
  // margin: 0 13px;
  height: 53px;
  line-height: 53px;
  border-bottom: 1px solid #d8d8d8;
  .tip {
    font-size: 14px;
    font-weight: 500;
    color: #999;
  }
  input {
    width: 275px;
    height: 16px;
    // margin-top: 5px;
    line-height: 17px;
    font-size: 15px;
    font-weight: 500;
    color: #999;
    text-indent: 5px;
    border: none;
    background: none;
    outline: none;
  }
  .input_code {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    font-size: 15px;
    font-weight: 500;
    background: none;
    border: none;
    outline: none;
  }
}

.btn {
  display: block;
  width: 339px;
  height: 43px;
  margin: 98px auto 0;
  font-size: 14px;
  font-weight: bold;
  color: #fff;
  line-height: 43px;
  background: #07c160;
  border-radius: 21px;
  border: none;
  outline: none;
  transition: all 0.15s linear;
}
.btn[disabled] {
  background: rgba(7, 193, 96, 0.16);
}
.des {
  position: fixed;
  bottom: 20px;
  width: 100%;
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  color: #999;
  text-align: center;
}
.des span {
  color: #ff6600;
}
</style>
